/*
 * The idea here is to keep an iframe and it's content in sync on sizing when the content wants to maintain an
 * unknown and perhaps changing (perhaps due to media queries) aspect ratio.
 *
 * To synchronize between the iframe and it's content we use the postMessage facilities which will work
 * across domains. See https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
 *
 * The protocol goes like this.
 * The child (content) asks the parent for the available size.
 * The child then sizes itself and sends it's actial size to the parent. This may or may not fit the available size.
 * The parent then sizes itself to fit (as best as possible) the child.
 * Whenever the parent resizes, we start the process all over again.
 */
import Messenger from "@/common/Messenger";

export default class ChildMessenger extends Messenger {
  reportInitialized() {
    this.postMessage("initialized");
  }

  reportMediaReady() {
    this.postMessage("media_ready");
  }

  reportExit() {
    this.postMessage("exit");
  }

  experienceNotFound() {
    this.postMessage("error", {
      error: "experience_not_found",
    });
  }
}
